import { useQuery } from "@tanstack/react-query";
import { AutoComplete } from "@/model";
import autocompleteRepository from "@/repository/autoCompleteRepository";


const getData = async (agentId: number, autocompleteId: string) => {
    const res = await autocompleteRepository.read(agentId, autocompleteId);
    return res.data.data;
};

export const useAutocomplete = (agentId: number, autocompleteId: string) => {
    return useQuery<AutoComplete>({
        queryKey: ["agent", agentId, "autocomplete", autocompleteId],
        queryFn: async () => getData(agentId, autocompleteId),
        retry: false
    });
};
